/**
 * 設定共通関数
 *
 * @author hayakawa 2023.10.18
 */

// インポート
import { $spinner } from '../_constants';

// 定数
const $flash_message = $('#flash-message'),
    $form_default_shift = $('#form-default-shift'),
    $form_default_shift_modal = $('#form-default-shift-modal'),
    $form_setting_others = $('#form-setting-others');

/**
 * モーダル 行生成
 *
 * @param {object} obj
 * @param {number} default_work_type
 * @returns {void}
 * @author hayakawa 2023.10.17
 */
export const cloneDefaultWork = (obj, default_work_type = 0) => {
    const free_start_time = $form_default_shift_modal.find('[name=free_start_time]').val(),
        free_end_time = $form_default_shift_modal.find('[name=free_end_time]').val(),
        $tr = $('.default-work.d-none').clone(false);
    let c = $('#btn-append-tr').val();

    $tr.removeClass('d-none');
    $tr.find('select, input').prop('disabled', false);
    if (obj) {
        $tr.find('[name="work_type[]"]').attr('id', `work-type-${c}`).val(obj.work_type).removeClass('placeholder');
        $tr.find('[name="work_time_from[]"]').attr('id', `work-time-from-${c}`).val(obj.work_from_hi);
        $tr.find('[name="work_time_to[]"]').attr('id', `work-time-to-${c}`).val(obj.work_to_hi);
    } else {
        const default_work_type = $form_default_shift_modal.find('[name=default_work_type]').val();
        $tr.find('[name="work_type[]"]').attr('id', `work-type-${c}`).val(default_work_type);
        $tr.find('[name="work_time_from[]"]').attr('id', `work-time-from-${c}`).val(free_start_time);
        $tr.find('[name="work_time_to[]"]').attr('id', `work-time-to-${c}`).val(free_end_time);
        if (default_work_type) {
            $tr.find('[name="work_type[]"]').removeClass('placeholder');
        }
    }
    $('.table-modal-shift').find('tbody').append($tr);
    $('#btn-append-tr').val(Number(c) + 1);
    return true;
};

/**
 * デフォルト出勤時間データを保存
 *
 * @returns {void}
 * @author hayakawa 2023.10.17
 */
export const saveDefaultShift = () => {
    const $form_data = new FormData($form_default_shift.get(0)),
        params = new URLSearchParams($form_data),
        $btn = $('button'),
        btn_html = $('#btn-save-default-shift').html();

    $btn.prop('disabled', true);
    $('#btn-save-default-shift').html($spinner);
    axios.post(VALIDATE_STORE_DEFAULT_SHIFT_API_ENDPOINT, params)
    .then(res => {
        $flash_message.find('.exec-result-message').html('').hide();
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        $form_default_shift.trigger('submit');
    })
    .catch(err => {
        const errors = err.response.data.errors;
        console.log(errors);
        let html = `<ul>\n`;
        $form_default_shift.find('.is-invalid').removeClass('is-invalid');
        $form_default_shift.find('.invalid-feedback').text('');
        $.each(errors, function(k, v) {
            const keys = k.split('.'),
                input_name = keys[0],
                input_eq = keys[1],
                id = $form_default_shift.find(`[name="${input_name}[${input_eq}]"]`).attr('id');
            $form_default_shift.find(`[name="${input_name}[${input_eq}]"]`).addClass('is-invalid');
            $form_default_shift.find(`[name="${input_name}[${input_eq}]"]`).next().text(v);
            if (id === undefined) {
                html += `<li>${v}</li>\n`;
            } else {
                html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
            }
        })
        html += `</ul>\n`;
        $flash_message.find('.exec-result-message').html(html).show();
    })
    .finally(() => {
        $('#btn-save-default-shift').html(btn_html);
        $btn.prop('disabled', false);
    })
};

/**
 * その他データを保存
 *
 * @returns {void}
 * @author hayakawa 2023.10.18
 */
export const saveSettingOthers = () => {
    const $form_data = new FormData($form_setting_others.get(0)),
        params = new URLSearchParams($form_data),
        $btn = $('button'),
        btn_html = $('#btn-save-setting-others').html();

    $btn.prop('disabled', true);
    $('#btn-save-setting-others').html($spinner);
    axios.get(`${VALIDATE_STORE_SETTING_OTHERS_API_ENDPOINT}?${params.toString()}`)
    .then(res => {
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        $flash_message.find('.exec-result-message').html('').hide();
        $form_setting_others.trigger('submit');
    })
    .catch(err => {
        const errors = err.response.data.errors;
        let html = `<ul>\n`;
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        $.each(errors, function(k, v) {
            const id = $(`[name=${k}]`).attr('id');
            $(`[name=${k}]`).addClass('is-invalid');
            $(`[name=${k}]`).closest('li').find('.invalid-feedback').text(v).show();
            if (id === undefined) {
                html += `<li>${v}</li>\n`;
            } else {
                html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
            }
        })
        html += `</ul>\n`;
        $flash_message.find('.exec-result-message').html(html).show();
    })
    .finally(() => {
        $('#btn-save-setting-others').html(btn_html);
        $btn.prop('disabled', false);
    })
};
